import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.244 9.985A6.02 6.02 0 0 1 7.229 16h-2.13a.64.64 0 0 1-.638-.639v-.213c0-.352.286-.638.639-.638h2.129a4.53 4.53 0 0 0 4.524-4.525A4.53 4.53 0 0 0 7.23 5.461H3.3l2.705 2.705c.29.29.29.763 0 1.054a.763.763 0 0 1-1.054 0L.975 5.243a.74.74 0 0 1-.219-.527.74.74 0 0 1 .219-.527L4.952.21a.763.763 0 0 1 1.054 0c.29.29.29.763 0 1.054L3.301 3.97h3.928a6.02 6.02 0 0 1 6.015 6.015"
    }, null, -1)
  ]))]))
}
export default { render: render }